import React from 'react'
import Link from 'next/link'

import { Tab, TabList, Tabs } from '@wartek-id/tabs'

import { DesktopPageHeader, PageContainer } from 'components/ResponsiveLayout'
import { useDesktopForYouTabToggle } from 'app/PelatihanMandiriPage/hooks/useDesktopForYouTabToggle'

type DesktopLandingShellProps = {
  activeMenu: 'untuk-anda' | 'topik' | 'aksi-nyata'
  children: React.ReactNode
}

const PAGE_TITLE = 'Pelatihan Mandiri'
const HELPDESK_LINK =
  'https://pusatinformasi.rumahpendidikan.kemendikdasmen.go.id/hc/id/sections/46355859184793-Pelatihan-Mandiri'

const navItems = [
  {
    name: 'untuk-anda',
    label: 'Untuk Anda',
    href: '/pelatihan-mandiri',
  },
  {
    name: 'topik',
    label: 'Topik',
    href: '/pelatihan-mandiri/daftar-topik',
  },
  {
    name: 'aksi-nyata',
    label: 'Aksi Nyata',
    href: '/pelatihan-mandiri/daftar-aksi-nyata',
  },
] as const

const DesktopLandingShell = ({
  activeMenu,
  children,
}: DesktopLandingShellProps) => {
  const { isEnabled: shouldShowForYouTab } = useDesktopForYouTabToggle()
  const visibleNavItems = shouldShowForYouTab
    ? navItems
    : navItems.filter((item) => item.name !== 'untuk-anda')

  return (
    <div className="min-h-screen bg-gray-10">
      <DesktopPageHeader
        navLinks={[{ label: 'Bantuan', href: HELPDESK_LINK, external: true }]}
        breadcrumbItems={[{ label: PAGE_TITLE, href: null }]}
        bottomBar={
          <div className="border-b border-gray-20 bg-white">
            <PageContainer className="!py-0">
              <Tabs
                withBorder
                selectedIndex={visibleNavItems.findIndex(
                  (item) => item.name === activeMenu
                )}
                onChange={(index) => {
                  window.location.href = visibleNavItems[index].href
                }}
              >
                <TabList
                  style={{
                    borderBottom: '1px solid var(--color-border-subdued)',
                  }}
                >
                  {visibleNavItems.map((item) => (
                    <Tab key={item.name}>
                      <Link href={item.href} passHref legacyBehavior>
                        <a
                          className="flex w-full items-center justify-center"
                          data-testid={item.name}
                        >
                          {item.label}
                        </a>
                      </Link>
                    </Tab>
                  ))}
                </TabList>
              </Tabs>
            </PageContainer>
          </div>
        }
      />
      <PageContainer className="pt-6">{children}</PageContainer>
    </div>
  )
}

export default DesktopLandingShell
